'use client'
import { Flex, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import ChevronRight from '@/assets/icons/chevron-right.svg'
import useVisitCoin from '@/hooks/business/useVisitCoin'
import { I18nLink } from '@/i18n/navigation'

import { useCoinContext } from '../_contexts/CoinContext'

export default function CoinDetailHeader() {
  const { coin } = useCoinContext()
  const t = useTranslations('common')
  useVisitCoin(coin.token_id)
  return (
    <Flex align={'center'} mb={32}>
      <I18nLink href={'/'} prefetch={true}>
        <Text c={'var(--content-secondary)'} variant={'subtitle'}>
          {t('Market')}
        </Text>
      </I18nLink>
      <ChevronRight height={16} fill={'var(--content-tertiary)'} />
      <Text variant={'subtitle'} c={'var(--content-primary)'}>
        {coin.name}
      </Text>
    </Flex>
  )
}
